import formatDate, { type Options } from './formatDate';

const formatDatetime = (datetime: string | null, options?: Options) => {
  if (!datetime) return null;

  return formatDate(new Date(datetime), options);
};

export default formatDatetime;
